import container from './component';

export default container;
